import React from 'react';


import {
    Select,
} from "@tencent/spaui"

const Component = (props) => {
    const {
        valid,
        ...others
    } = props || {};
    return (
        <div className={valid ? '' : 'has-error'}>
            <Select {...others} />
        </div>

    );
}

export default Component;